import '../styles/spinner.css'

const Spinner = () => <div className="loader">Loading...</div>
export default Spinner;
